










































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetTerms } from "@/request/projects";
import { GetOssParams } from "@/request/edr";
import * as OSS from "ali-oss";
import Jiatingzhuzhi from "./custom-contents/jiatingzhuzhi.vue";
import Zhusu from "./custom-contents/zhusu.vue";
import Xianbingshi from "./custom-contents/xianbingshi.vue";
import Zhongyaoyinpian from "./custom-contents/zhongyaoyinpian.vue";
import Qitayongyao from "./custom-contents/qitayongyao.vue";
import Wenjian from "./custom-contents/wenjian.vue";
@Component({
  components: {
    Jiatingzhuzhi,
    Zhusu,
    Xianbingshi,
    Zhongyaoyinpian,
    Qitayongyao,
    Wenjian
  }
})
export default class EdrTemplateTransfer extends Vue {
  @Prop()
  private index: any;
  @Prop()
  private content: any;
  private resultOptions: any[] = [];
  private ossReady: boolean = false;
  private get ossClient() {
    return this.$store.state.ossClient;
  }
  /**
   * @description 获取store中的可编辑状态
   */
  private get ifCompose() {
    return this.$store.state.edrIfCompose;
  }
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  @Watch("content.type", { immediate: true })
  private contentTypeChange(type) {
    if (this.content["type"] === "搜索多选") {
      this.$nextTick().then(() => {
        this.resultOptions = this.content.value;
      });
    }
    if (this.content["type"] === "文件") {
      // this.createOss().then(() => {
      //   this.ossReady = true;
      // });
    }
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    let searchType: string = this.content["title"];
    if (searchType === "伴随症状") {
      searchType = "中医症状";
    }
    const params: any = {
      params: {
        type: searchType,
        search: ev
      }
    };
    GetTerms(this, params).then((data: any) => {
      this.resultOptions = data.concat(this.content.value);
    });
  }
  /**
   * @description 计算是否应该是灰色背景
   */
  private calGrayBack(index) {
    // 3,4,7,8,11,12,15,16,19,20
    index++;
    const t = (index + 1) % 4;
    if (t === 0) {
      return true;
    }
    if (index % 4 === 0) {
      return true;
    }
    return false;
  }
  /**
   * @description 创建oss
   */
  private createOss() {
    return new Promise((resolve, reject) => {
      GetOssParams(this).then((data: any) => {
        const client = new OSS({
          accessKeyId: data.Credentials.AccessKeyId,
          accessKeySecret: data.Credentials.AccessKeySecret,
          stsToken: data.Credentials.SecurityToken,
          endpoint: data.endpoint,
          bucket: data.bucket
        });
        this.$store.commit("updateOss", client);
        resolve();
      });
    });
  }
}
